import { render, staticRenderFns } from "./AddButtonText.vue?vue&type=template&id=5234bb7c"
import script from "./AddButtonText.vue?vue&type=script&lang=js"
export * from "./AddButtonText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports